import React from 'react'

import Table from './Table'
import { Column } from './Table'

/**
   dataField:string    // field name as data item
   caption:string /// title of header cell 
   valuesStringType:string /// text in cell that write after value cell (units value)
   withPercent:boolean /// if need add percent in end cell text content. work only if table have totalRowFields 
   align:string /// align content in cell 
   cellRender:function //// function for rendering custom cell content/ Have params is data item
   isSort:boolean //// if need add sort button in header of column
   classNameBodyCell /// html class name for cell td
 */

const TableGroup = ({ children }) => {
  return <div className="table_group_container">{children}</div>
}

Table.Column = Column
Table.TableGroup = TableGroup

export default Table
